'use client'

import { CustomFlowbiteTheme, Dropdown, DropdownItem } from 'flowbite-react'
import { useSearchParams } from 'next/navigation'

const customDropdownTheme: CustomFlowbiteTheme['dropdown'] = {
  floating: {
    target:
      'rounded-lg enabled:hover:bg-white enabled:hover:text-gray-900 :ring-gray-100 focus:text-gray-900',
  },
}

const sortFields = [
  { name: 'Newest', value: 'newest' },
  { name: 'Oldest', value: 'oldest' },
  { name: 'Featured', value: 'featured' },
]

export default function BountySort() {
  const searchParams = useSearchParams()

  const handleSort = (value: string) => {
    const params = new URLSearchParams(searchParams)
    params.set('sort', value)
    params.set('page', '1')
    window.history.replaceState(null, '', `?${params.toString()}`)
  }

  return (
    <Dropdown
      theme={customDropdownTheme}
      className="bg-gray-50"
      label="Sort"
      color="gray"
      pill
    >
      {sortFields.map((field, index) => (
        <DropdownItem key={index} onClick={() => handleSort(field.value)}>
          {field.name}
        </DropdownItem>
      ))}
    </Dropdown>
  )
}
